<template>
<div>
  <navigation></navigation>
  <!--Main contents-->
  <div class="box_center" id="page_x">
    <h2 class="shadow" style="float: left">Admin</h2>
    <br>
    <br>
    <br>
    <ul class="articles">
      <li><router-link :to="{path: '/managerecord'}">Manage Record</router-link></li>
    </ul>
  </div>
</div>
</template>

<script>
import Nav from '../components/Nav'
export default {
  components: {
    'navigation': Nav
  },
  data () {
    return {

    }
  },
  metaInfo: {
    title: 'Admin'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Admin.vue?4762f022